import { Menubar } from 'primereact/menubar'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Button } from 'primereact/button'
import { navbarLogo } from '../../assets'
import { LANG } from '../../constants'

export default function NavBar () {
  const n = useNavigate()
  const { t, i18n } = useTranslation()

  const setLang = (val : string) => {
    localStorage.setItem(LANG.STORAGE_NAME, val)
    i18n.changeLanguage(val)
  }

  const start = () => {
    return <Button link onClick={() => n('/')} >
      <img
        style={{ height: '50px' }}
        src={navbarLogo}
        alt={`${t('image.logo_description')}`}
      />
    </Button>
  }

  const model = () => {
    return [
      {
        label: t('navbar.home'),
        icon: 'pi pi-fw pi-home',
        command: () => { n('/') }
      },
      {
        label: t('navbar.tools'),
        icon: 'pi pi-fw pi-box',
        items: [{
          label: 'Looper - Streaming',
          icon: '',
          command: () => { window.open('https://www.unipigstudio.com/looper/index.html', '_blank')?.focus() }
        }],
      },
      {
        label: t('navbar.articles.title'),
        icon: 'pi pi-fw pi-file',
        items: [
          {
            label: t('navbar.articles.article_01.title'),
            icon: '',
            command: () => { window.open(t('navbar.articles.article_01.url'), '_blank')?.focus() }
          },
          {
            label: t('navbar.articles.article_02.title'),
            icon: '',
            command: () => { window.open(t('navbar.articles.article_02.url'), '_blank')?.focus() }
          },
          {
            label: t('navbar.articles.article_03.title'),
            icon: '',
            command: () => { window.open(t('navbar.articles.article_03.url'), '_blank')?.focus() }
          }
        ]
      },
      {
        label: t('navbar.language'),
        icon: 'pi pi-fw pi-language',
        items: [
          {
            label: 'English',
            icon: '',
            command: () => setLang('en')
          },
          {
            label: 'Español',
            icon: '',
            command: () => setLang('es')
          },
          {
            label: 'Português (BR)',
            icon: '',
            command: () => setLang('pt')
          }
        ]
      }
    ]
  }

  return <Menubar start={start()} model={model()} />
}